import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPayrollItemEmployee from './payroll-item-employee.reducer';

export const selectPayrollItemEmployeeState = createFeatureSelector<fromPayrollItemEmployee.State>(
    fromPayrollItemEmployee.payrollItemEmployeesFeatureKey
);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromPayrollItemEmployee.adapter.getSelectors(
    selectPayrollItemEmployeeState
);
